import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '447881420773'; // WhatsApp number without + or spaces
  const message = encodeURIComponent("Hello, I'm interested in the GPS Method");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <>
      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center"
          aria-label="Open WhatsApp chat"
        >
          {isOpen ? (
            <X size={28} />
          ) : (
            <MessageCircle size={28} />
          )}
        </button>
      </div>

      {/* WhatsApp Popup */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 z-50 w-80 bg-white rounded-lg shadow-2xl overflow-hidden animate-slide-up">
          {/* Header */}
          <div className="bg-green-500 text-white p-4">
            <div className="flex items-center gap-3">
              <div className="bg-white rounded-full p-2">
                <MessageCircle size={24} className="text-green-500" />
              </div>
              <div>
                <h3 className="font-semibold text-lg">GPS Method™</h3>
                <p className="text-sm opacity-90">Typically replies instantly</p>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="p-6 bg-gray-50">
            <div className="bg-white rounded-lg p-4 shadow-sm mb-4">
              <p className="text-gray-700 text-sm leading-relaxed">
                👋 Hello! Welcome to the GPS Method™.
              </p>
              <p className="text-gray-700 text-sm leading-relaxed mt-2">
                How can we help you today?
              </p>
            </div>

            {/* WhatsApp Button */}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-green-500 hover:bg-green-600 text-white text-center py-3 px-4 rounded-lg font-semibold transition-colors duration-200"
            >
              Start Chat on WhatsApp
            </a>
          </div>

          {/* Footer */}
          <div className="bg-gray-100 px-4 py-2 text-center">
            <p className="text-xs text-gray-600">
              Powered by WhatsApp
            </p>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default WhatsAppWidget;
